import React from 'react';
import { Section } from './Section';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <Section className="bg-brand-light !py-4 md:!py-6" data-id="element-164" data-mp="1o2vhoq8r8p73">
      <div className="max-w-3xl mx-auto flex items-center justify-center gap-3 rounded-xl border border-white/10 bg-brand-dark/55 px-4 py-3 text-center" data-id="element-165" data-mp="22367dpybvxqo">
        <ShieldCheckIcon className="w-5 h-5 shrink-0 text-brand-accent" data-id="element-166" data-mp="1x54qnbodkaid" />
        <p className="text-xs md:text-sm text-gray-200" data-id="element-167" data-mp="19fsi8e0vg6h4"><strong className="text-white" data-id="element-168" data-mp="19ceg96w4dza7">Garantía 7 días.</strong> Revisá Stretching 360 y Cuerpo Seguro Pro™; si no es para vos, te devolvemos el 100%.</p>
      </div>
    </Section>;
}